import React from 'react';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import process from '../../../assets/PowellPage/Roofing_Replacement_Process_ultimateroofing.jpg';

const RoofingProcess = () => {
  const steps = [
    {
      id: "01",
      title: "Free Inspection",
      text: "We inspect your roof for free to find damage and provide expert guidance today."
    },
    {
      id: "02",
      title: "Estimate",
      text: "We provide a detailed roofing estimate with transparent pricing options now."
    },
    {
      id: "03",
      title: "Material Selection",
      text: "We help you choose durable roofing materials for long-lasting protection."
    },
    {
      id: "04",
      title: "Installation",
      text: "Our skilled team installs new roofing systems with quality workmanship."
    },
    {
      id: "05",
      title: "Final Inspection",
      text: "We conduct a final inspection to ensure roof quality and customer satisfaction."
    }
  ];

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  return (
    <section className="cs-section replacement-process" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container">
        <div className="row align-items-stretch">

          {/* LEFT SIDE */}
          <motion.div
            className="col-lg-6 d-flex flex-column"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            {/* Title একদম উপরে */}
            <h2 className="cs-title cs-title-to-content roofing-header text-lg-start text-md-center">
              Our Roofing Process
            </h2>

            {/* Image বাকি সব জায়গা নেবে */}
            <motion.div
              className="roofing-image-wrapper flex-grow-1"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.4 }}
              style={{ minHeight: '420px' }}
            >
              <img
                src={process}
                alt="Roofing Process"
                className="roofing-image"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block'
                }}
              />
            </motion.div>
          </motion.div>

          {/* RIGHT SIDE */}
          {/* offset-lg-1 removed and col-lg-5 changed to col-lg-6 to eliminate the gap */}
          <div className="col-lg-6 mt-5 mt-lg-0 d-flex align-items-center">
            <motion.div
              className="position-relative w-100"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
            >
              {/* Vertical Line */}
              <motion.div
                className="roofing-line"
                initial={{ height: 0 }}
                whileInView={{ height: '95%' }}
                transition={{ duration: 1.5, ease: "easeInOut" }}
              />

              {steps.map((step, index) => (
                <motion.div
                  key={index}
                  className="d-flex mb-4 position-relative roofing-step"
                  variants={fadeInUp}
                  whileHover={{ scale: 1.05 }}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 15
                  }}
                >
                  {/* Step Circle */}
                  <motion.div
                    className="roofing-step-circle"
                    whileHover={{
                      scale: 1.2,
                      rotate: 10,
                      boxShadow: "0 0 15px #3D3B6D"
                    }}
                    transition={{ duration: 0.4 }}
                  >
                    {step.id}
                  </motion.div>

                  {/* Step Text */}
                  <motion.div
                    whileHover={{ color: "#3D3B6D" }}
                    transition={{ duration: 0.3 }}
                  >
                    <h3 className="roofing-step-title">{step.title}</h3>
                    <p className="service-p">{step.text}</p>
                  </motion.div>
                </motion.div>
              ))}
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default RoofingProcess;